import React, { useEffect, useState } from 'react'
import { DefaultButton, IDropdownOption, MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';

import { IChoiceField, IField, ITextField, IUser } from '../../../shared/interfaces';
import DynamicForm from '../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { RootState } from '../../../store';
import { connect, ConnectedProps } from 'react-redux';
import { AddEditUserAoo_Mode } from '../../../shared/enums';
import Utilities from '../../../shared/Utilities/utilities';
import { RouteComponentProps, withRouter } from 'react-router-dom';



const mapState = (state: RootState) => ({
    allRoles: state.sessionReducer.allRoles,
    userActiveAoo: state.sessionReducer.userActiveAoo
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface EditUserAooProps {
    loading?: boolean
    extraCssClass?: string
    selectedUser: IUser
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (userItem: IUser, addEditUserMode: AddEditUserAoo_Mode) => void
    onDismiss: () => void
    panelIsEdit: boolean

    peopleList: IUser[]
}

type Props = EditUserAooProps & RouteComponentProps & PropsFromRedux

const EditUserAoo: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [defaultAooOptions, setDefaultAooOptions] = useState<IDropdownOption[]>([]);


    useEffect(() => {

        //if (defaultAooOptions.length === 0) {

        //    // Ricavo le Aoo di cui l'utente fa parte
        //    aooService.getActiveAooForCurrentUser()
        //        .then((aoo) => {
        //            let aooOptions = aoo.map(el => { return { text: el.name, key: el.id } })
        //            setDefaultAooOptions(aooOptions);
        //        });

        //} else {
        resetFields();
        dismissMessageBar();
        //}

    }, []);

    useEffect(() => {
        resetFields();
    }, [props.selectedUser]);

    useEffect(() => {
        let aooOptions = props.userActiveAoo ? props.userActiveAoo.map(el => { return { text: el.name, key: el.id } }) : [];
        setDefaultAooOptions(aooOptions);
    }, [props.userActiveAoo]);


    useEffect(() => {
        if (defaultAooOptions.length > 0) {
            resetFields();
        }
    }, [defaultAooOptions]);

    const resetFields = () => {
        let personaReadOnly = false;
        let personaValue: any[] = [];

        let defaultAooValue;
        let userEmailValue;
        //let notificaGiornalieraValue;

        let personaSelezionata = { ...props.selectedUser };
        //Quando seleziono un utente, vuol dire che sto in modifica e tiro su i dati
        if (personaSelezionata) {
            personaReadOnly = true;

            // Per l'user
            personaValue.push({

                key: personaSelezionata.userId,
                imageUrl: personaSelezionata.imageUrl,
                imageInitials: personaSelezionata.initials,
                presence: personaSelezionata.presence,
                text: personaSelezionata.displayName,
                secondaryText: personaSelezionata.userId,
                showSecondaryText: true,
                hidePersonaDetails: false,
                user: personaSelezionata

            });

            // Per Defaul Aoo
            defaultAooValue = personaSelezionata.defaultAoo?.id;

            // Per l'email
            userEmailValue = personaSelezionata.emailNotifica;

            // Per notifica giornaliera
            //notificaGiornalieraValue = personaSelezionata.notificaGiornaliera;


        }

        //ricreo i fields a partire da initialFields e aggiungo le options per il field ruolo e per il default Aoo
        let newFields = [
            {
                displayName: "Default Aoo",
                internalName: "defaultAoo",
                sharepointType: "Choice",
                controlType: "dropdown",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: defaultAooValue,
                valid: false,
                touched: false,
                multi: false,
                options: defaultAooOptions

            } as IChoiceField,
            {
                displayName: "Email Notifica",
                internalName: "email",
                sharepointType: "Text",
                controlType: "textbox",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: userEmailValue ? userEmailValue : personaSelezionata?.userId,
                valid: false,
                touched: false,
                pattern: Utilities.GetRegexEmailSingola(),
            } as ITextField,
            //    {
            //        displayName: "Notifica Giornaliera",
            //        internalName: "notificaGiornaliera",
            //        sharepointType: "Yes/No",
            //        controlType: "boolean",
            //        required: false,
            //        readonly: false,
            //        disabled: false,
            //        system: false,
            //        internalValue: notificaGiornalieraValue,
            //        valid: false,
            //        touched: false
            //    } as IField
        ];

        setFields(newFields);
    }

    // Click su salva del panel laterale
    const editUsersAooSubmit = () => {

        if (checkUserAooManagerFormValidity()) {
            let personaSelezionata = { ...props.selectedUser };

            let defaultAooId = fields.find(el => el.internalName === 'defaultAoo')?.internalValue;
            let emailNotifica = fields.find(el => el.internalName === 'email')?.internalValue;
            let notificaValue = fields.find(el => el.internalName === 'notificaGiornaliera')?.internalValue;
            let notificaGiornaliera = notificaValue ? true : false;
            let isSuperAdmin = undefined;

            props.onSubmit({ ...personaSelezionata, defaultAooId, emailNotifica, notificaGiornaliera, isSuperAdmin }, AddEditUserAoo_Mode.EditUserOnly);

            resetFormFields();
        }
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkUserAooManagerFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);

        dismissMessageBar();

        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={editUsersAooSubmit}
                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>

            {messageBarIsVisible &&
                <MessageBar
                    messageBarType={messageBarType}
                    isMultiline={false}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
            }

            <CircleLoader loaderClass='loader-large' loading={loading} />




            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>

                    <DynamicForm
                        fields={fields}
                        onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                    />
                    {onRenderLateralPanelFooterContent()}
                </div>


            </div>

        </React.Fragment>

    );
}

export default connector(withRouter(EditUserAoo));
